import Router from 'vue-router'

import vue from 'vue'
import admin from '@/views/admin/main'
import adminDb from '@/views/admin/db'
import adminDatasets from '@/views/admin/datasets'
import adminList from '@/views/admin/list'
import adminAdd from '@/views/admin/add'
import adminImport from '@/views/admin/import'
import adminForgotPwd from '@/views/admin/forgotPassword'
import adminResetPwd from '@/views/admin/resetPassword'
import zombieList from '@/views/admin/zombies'
import mission from '@/views/mission/main'
import main from '@/views/main/main'
import year from '@/views/mission/year'
import missionList from '@/views/mission/list'
import missionAdd from '@/views/mission/add'
import missionImport from '@/views/mission/import'
import login from '@/views/login/main'
import missionForgotPwd from '@/views/mission/forgotPassword'
import results from '@/views/surveillance/results'
import o4results from '@/views/surveillance/o4results'
import surveillances from '@/views/surveillance/list'
import establishments from '@/views/establishments/list'
import surveys from '@/views/surveillance/surveys'
import statistics from '@/views/sheets/statistics'
import importSheets from '@/views/sheets/import'
import exportSheets from '@/views/sheets/export'
import selectSurveillance from '@/views/sheets/select'
import caracteristics from '@/views/sheets/caracteristics'
import explaur from '@/views/surveillance/explaur'
import addSheet from '@/sui/views/sheet/add'
import denominators from '@/sui/views/denominators/main'
import sheet from '@/sui/views/sheet/main'
import data from '@/views/surveillance/data'
import evolution from '@/views/tools/evolution'
import cohorts from '@/views/tools/cohorts'
import participation from '@/views/tools/participation'
import map from '@/views/tools/map'
import caracEvolution from '@/views/tools/caracteristicsEvolution'
import freeCaracteristics from '@/views/tools/freeCaracteristics'
import tools from '@/views/tools/main'
import store from '@/store'

vue.use(Router)

const mainRoutes = [
  {
    path: '/region',
    name: 'region',
    component: mission,
    redirect: '/region/2021/surveillances',
    meta: { requiresCpias: true },
    children: [
      {
        path: ':year/',
        component: year,
        redirect: ':year/surveillances',
        children: [
          {
            path: 'surveillances',
            component: surveillances
          },
          {
            path: 'sheets/statistics',
            component: statistics
          },
          {
            path: 'data',
            component: data,
            meta: { requiresMedical: true }
          },
          {
            path: 'o4results',
            component: o4results,
            meta: { requiresMedical: true }
          }
        ]
      }
    ]
  },
  {
    path: '/tools',
    name: 'tools',
    component: tools,
    redirect: 'tools/caracteristics',
    children: [
      {
        path: 'evolution',
        component: evolution,
        meta: { requiresUser: true }
      },
      {
        path: 'caracteristicsEvolution',
        component: caracEvolution,
        meta: { requiresUser: true }
      },
      {
        path: 'cohorts',
        component: cohorts,
        meta: { requiresUser: true }
      },
      {
        path: 'caracteristics',
        component: freeCaracteristics,
        meta: { requiresAuth: true }
      },
      {
        path: 'participation',
        component: participation,
        meta: { requiresUser: true }
      },
      {
        path: 'map',
        component: map,
        meta: { requiresUser: true }
      }
    ]
  },

  {
    path: '/mission',
    name: 'mission',
    component: mission,
    redirect: 'mission/list',
    meta: { requiresUser: true },
    children: [
      {
        path: 'list',
        component: missionList
      },
      {
        path: 'add',
        component: missionAdd
      },
      {
        path: 'import',
        component: missionImport
      },
      {
        path: 'establishments',
        component: establishments
      },
      {
        path: 'sheets',
        component: selectSurveillance,
        meta: { requiresMedical: true },
        children: [
          {
            path: ':year/:id/denominators',
            component: denominators,
            children: [
              {
                path: ':st',
                component: addSheet,
                meta: {
                  scrollToTop: true
                }
              }
            ]
          },
          {
            component: sheet,
            path: ':year/:id/module/:st/',
            redirect: {
              path: ':year/:id/module/:st/add',
              query: {
                start: 'list'
              }
            },
            children: [
              {
                path: 'add',
                component: addSheet,
                meta: {
                  scrollToTop: true
                }
              },
              {
                path: ':sid/edit',
                component: addSheet,
                meta: {
                  scrollToTop: true
                }
              }
            ]
          }
        ]
      },
      {
        path: ':year/',
        component: year,
        redirect: ':year/surveillances',
        children: [
          {
            path: 'surveillances',
            component: surveillances
          },
          {
            path: 'surveys',
            component: surveys
          },
          {
            path: 'results',
            component: results
          },
          {
            path: 'sheets/statistics',
            component: statistics
          },
          {
            path: 'sheets/import',
            component: importSheets,
            meta: { requiresMedical: true }
          },
          {
            path: 'sheets/caracteristics',
            component: caracteristics,
            meta: { requiresMedical: true }
          },
          {
            path: 'sheets/export',
            component: exportSheets,
            meta: { requiresMedical: true }
          },
          {
            path: 'data',
            component: data,
            meta: { requiresMedical: true }
          },
          {
            path: 'o4results',
            component: o4results,
            meta: { requiresMedical: true }
          },
          {
            path: 'explaur',
            component: explaur
          }
        ]
      }
    ]
  },
  {
    path: '/admin',
    name: 'admin',
    meta: { requiresAdmin: true },
    component: admin,
    redirect: 'admin/list',
    children: [
      {
        path: 'list',
        component: adminList
      },
      {
        path: 'zombies',
        component: zombieList
      },
      {
        path: 'add',
        component: adminAdd
      },
      {
        path: 'import',
        component: adminImport
      },
      {
        path: 'db',
        component: adminDb
      },
      {
        path: 'datasets',
        component: adminDatasets
      }
    ]
  },
  {
    path: '*',
    redirect: '/mission'
  }
]

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/:id?/resetpassword',
      name: 'resetpassword',
      component: adminResetPwd
    },
    {
      path: '/admin/forgotpassword',
      name: 'adminforgotpassword',
      component: adminForgotPwd
    },
    {
      path: '/mission/forgotpassword',
      name: 'missionforgotpassword',
      component: missionForgotPwd
    },
    {
      path: '/',
      name: 'main',
      component: main,
      redirect: 'mission',
      children: mainRoutes,
      meta: { requiresAuth: true }
    }
  ]
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
  const requiresAdmin = to.matched.some(x => x.meta.requiresAdmin)
  const requiresUser = to.matched.some(x => x.meta.requiresUser)
  const requiresCpias = to.matched.some(x => x.meta.requiresCpias)
  const requiresMedical = to.matched.some(x => x.meta.requiresMedical)
  const state = store.getters['login/loginState']

  if ((requiresAuth && !state.isLoggedIn) ||
      (requiresAdmin && !state.isAdmin) ||
      (requiresUser && !state.isUser) ||
      (requiresCpias && !state.isCpias) ||
      (requiresMedical && !state.isMedical)) {
    next({ path: '/login', query: { to: to.fullPath } })
  } else {
    next()
  }
})

export default router
